<template>
  <div class="container">
    <CRow>
      <CCol sm="12" md="12" lg="12" xl="4" class="mt-4">
        <CCard>
          <CCardBody>
            <CRow class="flex">
              <div class="w-75 mx-auto">
                <CInput label="Documento" placeholder="Digite Documento" class="w-100" v-on:keypress="isNumber($event)"
                  v-model="document" @keypress.enter="mtdDocumentPersonal" />
              </div>
            </CRow>
            <CRow>
              <div v-if="qrUrl" class="mx-auto">
                <img :src="qrUrl" alt="Código QR" />
              </div>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="12" md="12" lg="12" xl="8" class="mt-4">
        <CCard class="my-0">
          <CCardBody>
            <div class="d-flex justify-content-between align-items-center">
              <h3>LISTA DE ASISTENCIA</h3>
              <p class="text-muted font-2xl font-bold text-black-50" id="fechaHora">{{ currentDateTime }}</p>
            </div>

            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead class="table-dark">
                  <tr>
                    <th>#</th>
                    <th>Personal</th>
                    <th>Entrada</th>
                    <th>Salida</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in data_personal" :key="index">
                    <td>{{ item.index }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.date_init }}</td>
                    <td>{{ item.date_end }}</td>
                  </tr>
                  <tr v-if="data_personal.length === 0">
                    <td colspan="4" class="text-center">No hay registros</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CCardBody>
        </CCard>

      </CCol>
    </CRow>
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "name", label: "Personal", _style: "width:10%;" },
  { key: "date_init", label: "Entrada", _style: "width:10%;" },
  { key: "date_end", label: "Salida", _style: "width:10%;" },
];
import { mapActions } from "vuex";
import QRCode from "qrcode";
import moment from "moment";

export default {
  name: "AsistenciaKatalynas",
  data() {
    return {
      uuid: "ec639660-cdd0-11ef-b1ed-73ff944b8587",
      document: "",
      fields,
      data: [],
      data_personal: [],
      qrUrl: null,
      currentDateTime: moment().format("DD/MM/YYYY, HH:mm:ss"),
      filter_init: null,
      intervalId: null, 
    };
  },
  created() {
    this.mtd_data();
    this.updateTime();
    setInterval(this.updateTime, 1000);
    this.filter_init = moment().format("YYYY-MM-DD");
    this.byasistencia();
  },
  mounted() {
    // Inicia el intervalo para actualizar la asistencia cada 10 segundos
    this.intervalId = setInterval(() => {
      this.byasistencia();
    }, 10000);
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    ...mapActions(["get", "post"]),
    updateTime() {
      this.currentDateTime = moment().format("DD/MM/YYYY, HH:mm:ss");
    },
    mtd_data() {
      this.get({
        url: `${this.$store.getters.get__url}/assists/katalinas/byPersonal/${this.uuid}`,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode === 200) {
            this.data = response.data.data.map((item, index) => ({
              ...item,
              name: `${item.name} ${item.last_name}`,
              index: index + 1,
            }));
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtdDocumentPersonal() {
      const found = this.data.find((item) => item.document === this.document);
      if (found) {
        const today = moment().format("YYYY-MM-DD");
        const uuid = found.company.uuid;
        const userId = found.user_id;
        const url = `${this.$store.getters.get__url}/assists/confirm/${uuid}/${userId}/${today}`;

        // Generar el QR
        QRCode.toDataURL(url, { width: 200, height: 200 })
          .then((qr) => {
            this.qrUrl = qr;
          })
          .catch((err) => {
            console.error("Error al generar QR:", err);
          });
      } else {
        Swal.fire({
          title: "Documento no encontrado",
          icon: "warning",
        });
        this.qrUrl = null;
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    byasistencia: function () {
      this.post({
        url: this.$store.getters.get__url + "/assists/byAssists/web",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter_init,
          company: this.uuid,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            const barbers = response.data.user;
            const data = response.data.data;

            // Mapeamos todos los barbers asegurándonos de que aparezcan en la lista
            this.data_personal = barbers.map((barber, index) => {
              // Buscamos si hay un registro en data que coincida con el user_id
              const record = data.find(item => item.user_id == barber.user_id);

              return {
                id: barber.user_id,
                name: `${barber.name} ${barber.last_name}`,
                date_init: record ? this.formatDateTime(record.date_init) : "",
                date_end: record ? (record.date_end === null ? "" : this.formatDateTime(record.date_end)) : "",
                index: index + 1,
              };
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    formatDateTime: function (dateTime) {
      const date = new Date(dateTime);
      const formattedDate = date.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      const formattedTime = date.toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
      return `${formattedDate} ${formattedTime}`;
    },
  },
};
</script>
